// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';

myw.FeatureSet = myw.MywClass.extend('FeatureSet', {
    /**
     * @class  A set of {@link Feature}
     * @constructs
     */
    initialize(features) {
        this.items = [];
        this._itemsByUrn = {};

        if (features) this.addAll(features);
    },

    /**
     * set the array of filtred features
     * @param  {array<string>} urns   feature urns
     */
    setFilteredItems(urns) {
        if (!urns) {
            //clear filter: .items becomes complete list
            this.items = _.values(this._itemsByUrn);
        } else {
            this.items = [];
            _.each(urns, urn => {
                this.items.push(this.getFeatureByUrn(urn));
            });
        }
    },

    /**
     * Returns the feature associated with the given urn
     * @param  {string} urn
     * @return {Feature}
     */
    getFeatureByUrn(urn) {
        return this._itemsByUrn[urn];
    },

    /**
     * Adds a feature to the set
     * @param {Feature} feature
     */
    add(feature) {
        feature.index = this.items.length;
        this.items.push(feature);
        this._itemsByUrn[feature.getUrn(true)] = feature;
    },
    /**
     * Adds a list of features to the set
     * @param {Array<Feature>} features
     */
    addAll(features) {
        // Add all of the provided features.
        for (let i = 0; i < features.length; i++) {
            this.add(features[i]);
        }
        this.totalCount = features.totalCount;
    },

    /**
     * Empties the set
     */
    removeAll() {
        // Remove all of the features.

        this.items = [];
        this._itemsByUrn = {};
    },

    /**
     * Whether the set is empty
     * @return {Boolean}
     */
    isEmpty() {
        return this.items.length === 0;
    },
    /**
     * The size of the set
     * @return {integer}
     */
    size() {
        return this.items.length;
    },

    /** shallow copy of self */
    clone() {
        const c = new myw.FeatureSet();
        c.items = this.items;
        c._itemsByUrn = this._itemsByUrn;
        c.totalCount = this.totalCount;
        return c;
    },

    /**
     * Returns feature elements as a GeoJSON feature collection
     */
    asGeoJson() {
        return {
            type: 'FeatureCollection',
            features: _.invoke(this.items, 'asGeoJson')
        };
    }
});

export default myw.FeatureSet;
